module.exports = __webpack_public_path__ + "img/scene5--unmasked.svg";